<template>
    <div id="container">
        <el-button type="primary" size="small" @click="goback" icon="el-icon-back" style="position: absolute; top: 91px; left: 10px">返回</el-button>
        <!-- <button @click="sendToken">11111</button> -->
        <!-- <iframe id="iframeContainer" src="https://edam.tscon.cn:7778/earthgo/reactflow/" style="width: 100%; height: 100%" frameborder="0"/> -->
        
        <!-- <iframe id="iframePlanBuild" src="http://192.168.1.40:5173/#/reportIndex" style="width: 100%; height: 100%" frameborder="0" /> -->
        <iframe id="iframePlanBuild" src="https://edam.tscon.cn:7778/wenda53/mcc/zhenchong_ml/wenda/#/reportIndex" style="width: 100%; height: 100%" frameborder="0" />
    </div>
</template>
<script>
import templateApi from "@/api/report";
export default {
    data() {
        return {
            token: "",
            template: {
                c_id: 0,
                c_data: ""
            },
            planId: 0,
            showPanel: false,
            // 控制选择面板的显示状态 
            panelTop: 0,
            // 选择面板的top位置 
            panelLeft: 0,
            // 选择面板的left位置 
            options: ['知识图谱', '拷贝', '导出'],// 选项 
            isShowEdit: false, // 编辑模板信息弹窗 
            fileForm: {
                name: '',
                desc: ''
            } // 编辑模板信息表单 
        }
    },
    mounted() {
        this.template.c_id = this.$route.params.id;
        this.planId = this.$route.params.planId;
        setTimeout(() => {
            this.postData();
        }, 1000)
        // document.getElementById("iframeEl").contentWindow.postMessage({ type: 'zc', data: JSON.stringify(res) }, '*')
        // window.addEventListener('message', (e) => {
        //     if (e.data.type == 'zhiShiTuPu') {
        //         let routerData = this.$router.resolve({ path: e.data.data });
        //         window.open(routerData.href, "_blank");
        //     }
        // }, false)
        // this.sendToken()
    },
    methods: {
        postData() {
            templateApi.getTemplateById({ c_id: this.template.c_id }).then(res => {
                if (res.data.code === 200) {
                    this.template.c_data = res.data.data.c_data;
                    document.getElementById("iframePlanBuild").contentWindow.postMessage({type: 'zc',data: JSON.stringify(
                        {
                            c_id: this.template.c_id,
                            c_data: this.template.c_data,
                            c_name: res.data.data.c_name,
                        }
                    )}, '*')
                }
            })
        },
        showContextMenu(event) { // 获取鼠标点击位置 
            // console.log("111111111111111111111111111111111111111");
            this.panelTop = event.clientY; 
            this.panelLeft = event.clientX; // 显示选择面板 
            this.showPanel = true;
        }, 
        handleOptionClick(option) { // 处理选项点击事件 
            console.log('Selected:', option); // 隐藏选择面板 
            this.showPanel = false;
            this.isShowEdit=true
        },
        goback() {
            this.$router.push({ path: '/reportNewW' })
        },
        // sendToken() {
        //     let iframe = document.getElementById("iframeContainer")
        //     iframe.onload = (() => {
        //         let send = document.getElementById("iframeContainer").contentWindow;
        //         send.postMessage(sessionStorage.getItem("token"), "*");
        //     })
        // }
    }
}
</script>
<style scoped>
#container {
    width: 100%;
    height: 100vh;
    /* margin-top: 30px; */
    overflow-y: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/Reports/PlanBuild1.vue